import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { checkCodeMeli } from '../utils/checkCodeMeli';
import { api } from '../services';
import { useDispatch } from 'react-redux';
import { setPaymentData } from '../store/slices/paymentSlice';
import DOMPurify from 'dompurify';
const baseUrl = process.env.REACT_APP_API_URL;


export const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Fname = localStorage.getItem('Fname');
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showTurnExistsModal, setShowTurnExistsModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const apiKey = process.env.REACT_APP_API_KEY;
  const oid=process.env.REACT_APP_OID;
 
  // Add function to check login status
  const checkLoginStatus = () => {
    const key = localStorage.getItem('key');
    return !!key;
  };

  // Add function to handle category 49 click
  const handleCategory49Click = () => {
    if (checkLoginStatus()) {
      // User is logged in, redirect to DoctorOnline
      navigate('/doctoronline');
    } else {
      // User is not logged in, redirect to login with return URL
      navigate('/login', { state: { returnUrl: '/doctoronline' } });
    }
    handleCloseModal();
  };
  

  // Add function to handle category with SortOrder 5 click
  const handleSortOrder5Click = () => {
    if (checkLoginStatus()) {
      // Update Redux state with sortOrder
      dispatch(setPaymentData({ sortOrder: 5 }));
      // User is logged in, redirect to DoctorOnline
      navigate('/doctoronline');
    } else {
      // Update Redux state with sortOrder
      dispatch(setPaymentData({ sortOrder: 5 }));
      // User is not logged in, redirect to login with return URL and SortOrder info
      navigate('/login', { state: { returnUrl: '/doctoronline', fromSortOrder: 5 } });
    }
    handleCloseModal();
  };

  useEffect(() => {
    const isPaymentSuccessful = localStorage.getItem('isPaymentSuccessful');
    const authority = localStorage.getItem('authority');
    const invoiceData = localStorage.getItem('invoiceData');

    localStorage.removeItem('appointmentData');
    localStorage.removeItem('time');
    localStorage.removeItem('num');
    localStorage.removeItem('date_n');
    localStorage.removeItem('doctor_id');
    localStorage.removeItem('doctor_name');
    localStorage.removeItem('doctor_famil');
    localStorage.removeItem('Price');
    localStorage.removeItem('payment_time');
    localStorage.removeItem('ServiceCategoryID');
    localStorage.removeItem('ServiceDoctorID');
    localStorage.removeItem('enableUpload');

    if (!isPaymentSuccessful) {
      localStorage.removeItem('isPaymentSuccessful');
      localStorage.removeItem('authority');
      localStorage.removeItem('invoiceData');
    }

    // Show modal if redirected with existing turn flag
    if (location.state?.turnExists) {
      setShowTurnExistsModal(true);
      // Clear history state so modal doesn't persist on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  let validCodeMeli = checkCodeMeli('0550348433');
  console.log(validCodeMeli);

  // const imageMap = {
  //   1: '/Img/icons/optometry-icon.png',
  //   2: '/Img/icons/medical-appointment.png',
  //   3: '/Img/icons/delete-glasses.png',
  //   4: '/Img/icons/doctor-online.png',
  //   5: '/Img/icons/medical_bag.png',
    
  // };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get(`home/ShowDoctorCategory?OID=1`);
        let data = response.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error('Invalid JSON string:', data);
            return;
          }
        }
        const sortedData = data.sort((a, b) => a.SortOrder - b.SortOrder);
        setCategories(sortedData);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  const handleOpenModal = (category) => {
    setSelectedCategory(category);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCategory(null);
  };

  const getLinkPath = (category) => {
    if ([1, 3, 4].includes(category.SortOrder)) {
      return `/doctorlist?OID=1&CategoryID=${category.ServiceCategoryID}&CategoryName=${category.ServiceCategoryName}`;
    } else if (category.SortOrder === 2) {
      return `/Survey?CategoryID=${category.ServiceCategoryID}&CategoryName=${category.ServiceCategoryName}`;
    }
    return '/';
  };

  return (
    <section>
      <style>
        {`
          .main_wrap {
            padding: 40px 0;
            text-align: center;
          }
          // .category-container {
          //   max-width: 1200px;
          //   margin: 0 auto;
          // }
          .category-row {
            display: flex;
            flex-wrap: nowrap; /* Single row on desktop */
            justify-content: center;
            gap: 20px;
            padding-bottom: 20px;
            overflow-x: auto; /* Horizontal scroll if needed */
          }
          .category-item {
            flex: 0 0 300px; /* Fixed width for each item */
            max-width: 300px;
          }
          .bg-cati {
            background: #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
            aspect-ratio: 1 / 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 20px;
            cursor: pointer;
          }
          .bg-cati.disabled {
            cursor: not-allowed;
            opacity: 0.7;
          }
          .bg-cati.disabled:hover::after {
            content: 'غیرفعال';
            position: absolute;
            background: rgba(0, 0, 0, 0.7);
            color: white;
            padding: 5px 10px;
            border-radius: 4px;
            font-size: 14px;
          }
          .bg-cati img {
            max-width: 90px;
            object-fit: contain;
          }
          .bg-cati img.small {
            max-width: 50px;
          }
          .bg-cati h2 {
            font-size: 1rem;
            font-weight: bold;
            margin-top: 16px;
            color: #333;
          }
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .modal-content {
            background: #fff;
            border-radius: 8px;
            max-width: 500px;
            width: 90%;
            direction: rtl;
            padding: 20px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          .modal-header {
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 1px solid #ddd;
            padding-bottom: 10px;
            width: 100%;
            position: relative;
          }
          .modal-title {
            font-size: 1.25rem;
            font-weight: bold;
            text-align: center;
            margin: 0;
          }
          .modal-close {
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            position: absolute;
            left: 0;
          }
          .modal-body {
            padding: 20px 0;
            text-align: center;
            width: 100%;
          }
          .modal-footer {
            display: flex;
            gap: 40px;
            justify-content: center;
            border-top: 1px solid #ddd;
            padding-top: 20px;
            width: 100%;
          }
          .modal-footer .btn {
            min-width: 120px;
            padding: 8px 20px;
            font-size: 0.9rem;
            border-radius: 6px;
            transition: all 0.2s ease;
          }
          .modal-footer .btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          @media (max-width: 768px) {
            .category-row {
              flex-direction: column; /* Stack items vertically */
              align-items: center; /* Center items horizontally */
              overflow-x: hidden; /* Remove horizontal scroll */
            }
            .category-item {
              flex: 0 0 auto; /* Allow natural width */
              max-width: 300px; /* Keep max width */
              width: 100%; /* Full width within container */
            }
          }
        `}
      </style>
      <div className="main_wrap">
        <div className="category-container">
          <div className="category-rows-wrapper">
            {/* ردیف اول - 3 آیتم */}
            <div className="category-row">
              {categories.slice(0, 3).map((category) => (
                <div key={category.ServiceCategoryID} className="category-item">
                  <div className="bg-cati">
                    <div
                      onClick={() => handleOpenModal(category)}
                      className="text-decoration-none text-dark d-flex flex-column justify-content-center align-items-center h-100"
                    >
                        <img
                          src={`${baseUrl}Home/ShowImg?Filename=${category.CatIcon}`}
                          alt={category.ServiceCategoryName}
                        />
                      <h2 className="category-title">{category.ServiceCategoryName}</h2>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* ردیف دوم - 2 آیتم باقیمانده */}
            <div className="category-row justify-content-center">
              {categories.slice(3).map((category) => (
                <div key={category.ServiceCategoryID} className="category-item">
                  <div className="bg-cati">
                    <div
                      onClick={() => handleOpenModal(category)}
                      className="text-decoration-none text-dark d-flex flex-column justify-content-center align-items-center h-100"
                    >
                        <img  
                          src={`${baseUrl}Home/ShowImg?Filename=${category.CatIcon}`}         
                          
                        alt={category.ServiceCategoryName}
                      />
                      <h2 className="category-title">{category.ServiceCategoryName}</h2>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <style jsx>{`
          .category-container {
            width: 100%;
            padding: 40px 20px;
          }
          
          .category-rows-wrapper {
            display: flex;
            flex-direction: column;
            gap: 30px;
            align-items: center;
            max-width: 1200px;
            margin: 0 auto;
          }

          .category-row {
            display: flex;
            justify-content: center;
            gap: 30px;
            width: 100%;
          }

          .category-item {
            width: 250px;
            height: 250px;
          }

          .bg-cati {
            width: 100%;
            height: 100%;
            background-color: #fff;
            border-radius: 15px;
            padding: 25px;
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
            transition: transform 0.2s, box-shadow 0.2s;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .bg-cati:hover {
            transform: translateY(-5px);
            box-shadow: 0 6px 12px rgba(0,0,0,0.15);
          }

          .category-icon {
            width: 100px;
            height: 100px;
            object-fit: contain;
            margin-bottom: 15px;
          }

          .category-title {
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            margin: 0;
            color: #333;
          }

          @media (max-width: 768px) {
            .category-item {
              width: 200px;
              height: 200px;
            }

            .category-icon {
              width: 80px;
              height: 80px;
            }

            .category-title {
              font-size: 16px;
            }
          }
        `}</style>

        {showModal && selectedCategory && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header ">
                <h2 className="modal-title">{selectedCategory.ServiceCategoryName}</h2>
                <button className="modal-close" onClick={handleCloseModal}>
               
                </button>
              </div>
              <div className="modal-body ">
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedCategory.Description || 'توضیحاتی برای این دسته‌بندی وجود ندارد.') }}></p>
              </div>
              <div className="modal-footer">
                {selectedCategory.SortOrder === 5 ? (
                  <>
                    <Button
                      variant="primary"
                      onClick={selectedCategory.SortOrder === 5 ? handleSortOrder5Click : handleCategory49Click}
                      style={{ backgroundColor: '#0db2ba', borderColor: '#0db2ba' }}
                    >
                      ادامه
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={handleCloseModal}
                      style={{ backgroundColor: '#495057', borderColor: '#dee2e6', color: '#e9ecef' }}
                    >
                      انصراف
                    </Button>
                  </>
                ) : selectedCategory.SortOrder === 4 ? (
                  <>
                    {/* <Button
                      variant="primary"
                      disabled
                      style={{ backgroundColor: '#0db2ba', borderColor: '#0db2ba', opacity: 0.5 }}
                    >
                      ادامه
                    </Button> */}
                    <Button
                      variant="secondary"
                      onClick={handleCloseModal}
                      style={{ backgroundColor: '#495057', borderColor: '#dee2e6', color: '#e9ecef' }}
                    >
                      انصراف
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="primary"
                      as={Link}
                      to={getLinkPath(selectedCategory)}
                      onClick={handleCloseModal}
                      style={{ backgroundColor: '#0db2ba', borderColor: '#0db2ba' }}
                    >
                      ادامه
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={handleCloseModal}
                      style={{ backgroundColor: '#495057', borderColor: '#dee2e6', color: '#e9ecef' }}
                    >
                      انصراف
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        <Modal show={showTurnExistsModal} onHide={() => setShowTurnExistsModal(false)} centered>
          <Modal.Header >
            <Modal.Title>اطلاع رسانی</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center" style={{ direction: 'rtl' }}>
            شما قبلا یک نوبت ثبت کرده‌اید.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => setShowTurnExistsModal(false)}>
              متوجه شدم
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </section>
  );
};